import { createContext } from "react";
import { ReactReduxContextValue } from "react-redux";

const CoreReduxContext = createContext({} as ReactReduxContextValue);

export default CoreReduxContext;
